// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"132ef876","439":"69e7bd80","770":"3080f3de","787":"774729bc","791":"01fd77c4","875":"f3d8cd15","880":"eed530fe"}[chunkId] + ".chunk.js";
};